import { createBundle } from 'widget/Common';

import DakaDownLoadView from 'bundle-loader?lazy&name=DakaDownLoadView!pages/DownLoad/daka/DakaDownLoadView';

import ShareAppView from 'bundle-loader?lazy&name=ShareAppView!pages/DownLoad/ShareApp/ShareAppView';

const RouterConfig = [
  {
    path: '/daka/download',
    title: '打卡下载App',
    component: () => {
      return createBundle(DakaDownLoadView);
    }
  },
  {
    path: '/share/app',
    title: '下载App',
    component: () => {
      return createBundle(ShareAppView);
    }
  }
];
export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/DownLoad/RouterConfig.js